<template>
  <div>
    <table class="basket-summary">
      <tr v-if="!quantity">
        <td colspan="2">There are no items in the basket</td>
      </tr>
      <tr v-else>
        <th>Total products</th>
        <td>{{ quantity }}</td>
      </tr>
      <tr v-if="basketValues.discount > 0">
        <th>Discount Code Applied {{ discountCode }}</th>
        <td class="y-basket-value" style="white-space: nowrap;" v-if="basketValues.discount">-£ {{basketValues.discount | money}}</td>
        <td class="y-basket-value" style="white-space: nowrap;" v-else>-£0</td>
      </tr>
      <tr>
        <th>Delivery:</th>
        <td v-if="basketValues.shipping">£ {{ basketValues.shipping | money }}</td>
        <td v-else colspan="2">£ {{ 0 | money }}</td>
      </tr>
      <tr>
        <th>Total (net):</th>
        <td v-if="basketValues.net" colspan="2">£ {{ basketValues.net | money }}</td>
        <td v-else colspan="2">£ {{ 0 | money }}</td>
      </tr>
      <tr>
        <th>VAT:</th>
        <td v-if="basketValues.tax" colspan="2">£{{ basketValues.tax | money }}</td>
        <td v-else colspan="2">£ {{ 0 | money }}</td>
      </tr>
        <tr v-if="basketValues.discount > 0">
            <th>Discount:</th>
            <td v-if="basketValues.discount" colspan="2">£{{ basketValues.discount | money }}</td>
            <td v-else colspan="2">£ {{ 0 | money }}</td>
        </tr>
      <tr>
        <th>Total:</th>
        <td v-if="basketValues.gross" colspan="2">£{{ basketValues.gross | money }}</td>
        <td v-else colspan="2">£ {{ 0 | money }}</td>
      </tr>
    </table>
  </div>
</template>
<script>

import {mapState} from 'vuex'
 
export default {
  el: '#basket-summary',
  data() {
    return {
      name: ''
    }
  },
  computed: {
    ...mapState(["basket", "basketValues", "discountCode", "discountApplied"]),
    quantity () {
      let total = 0;
      for (let i = 0; i < this.$store.state.basket.length; i++) {
        total += Number(this.$store.state.basket[i].quantity);
      }
      return total;
    },
  },


};
</script>